import { type ApiClient, attachment } from '../store/backend';
import { getStore } from '../store';
import { getOrganizationId } from '../store/selectors/organization/getOrganizationId';
import type { AttachmentViewModel } from '@trinnvis/dabih-api-client';
import type { AttachmentItem } from '../library/lists/attachment-item';
import { displayName } from '../utilities/text';
import { sortBy } from 'lodash';

export function toAttachmentItems(
  api: ApiClient,
  entityType: string,
  entityUuid,
  attachments: AttachmentViewModel[] | undefined,
  parentId?: string,
): AttachmentItem[] {
  const list = (attachments ?? []).map((a) => ({
    name: displayName(a.name),
    uuid: a.uuid,
    fullPath: a.fullPath ?? '',
    previewHref: a.urlForInline ?? '',
    downloadHref: a.url ?? '',
    asDocumentItem: async () => {
      // When offline, use already-known URLs instead of making an API call.
      // These URLs are UUID-based and immutable, so cached data is always valid.
      if (!navigator.onLine) {
        return {
          name: displayName(a.name),
          url: a.urlForInline ?? '',
          urlForDownload: a.url ?? '',
          entityType: entityType,
          attachmentId: a.uuid,
          uuid: entityUuid,
        };
      }
      const organizationId = getOrganizationId(getStore().getState());
      const a2 = await attachment(api, entityType, entityUuid, organizationId, a.uuid, parentId);
      return {
        name: displayName(a2.name),
        url: a2.urlForInline ?? '',
        urlForDownload: a2.url ?? '',
        entityType: entityType,
        attachmentId: a.uuid,
        uuid: entityUuid,
      };
    },
  }));
  return sortBy(list, [(x) => x.name]);
}
